export default __webpack_public_path__ + "static/media/tellihealth.4360ded0.svg";